export const MENU_VIEW_MODES = {
  HEATMAP: 'heatmap',
  SHEATMAP: 'sheatmap',
  CLICKS: 'clicks',
  PLAIN: 'plain'
}

// stats question column width — fallback when the wrap is not measurable
export const DEFAULT_CONTAINER_WIDTH = 826

export const DOT_RADIUS = 6
export const DOT_STROKE_WIDTH = 1.5
export const DOT_STYLE = 'fill: rgba(0, 159, 50, 1); stroke: #ffffff;'

// low density = green, high density = red
export const HEATMAP_COLORS = [
  '#FF5040',
  '#FF5C26',
  '#FF9326',
  '#FFC926',
  '#FFFF26',
  '#C9FF26',
  '#6FFF26',
  '#26FF38'
].reverse()

export const HEATMAP_OPACITY = [0.4, 0.5]
export const OVERLAY_OPACITY = [0.7, 0.7]

// fades the whole overlay for the heatmap-by-clicks view only
export const HEATMAP_IMAGE_OPACITY = 0.8

export const SECTION_STYLE = 'fill: transparent; stroke: #88D1CD; stroke-width: 2; vector-effect: non-scaling-stroke;'

export const EXPORT_OPTIONS = [
  { key: 'png', text: 'Download PNG image' },
  { key: 'jpeg', text: 'Download JPEG image' },
  { key: 'pdf', text: 'Download PDF document' },
  { key: 'eps', text: 'Download EPS file' }
]
